var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#searchIcon_svg__h2xtn1wfda)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.805 14.862l-3.977-3.977a6.666 6.666 0 10-.943.943l3.977 3.977.943-.943zM6.667 12a5.34 5.34 0 01-5.334-5.333 5.34 5.34 0 015.334-5.334A5.34 5.34 0 0112 6.667 5.34 5.34 0 016.667 12z",
    fill: "#222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "searchIcon_svg__h2xtn1wfda"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSearchIcon;